import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';

import { HisNotificationService, HisUiService, HisBaseGlobalsService } from 'hisng';
import { ResearchInfrastructureEmployment } from 'app/fs/res/research-infrastructure/model/research-infrastructure-classes';

@Component( {
    selector: 'res-research-infrastructure-edit-employment-wizard',
    templateUrl: './research-infrastructure-edit-employment-wizard.component.html',
} )
export class ResearchInfrastructureEditEmploymentWizardComponent implements OnInit {
    @Input() researchInfrastructureEmployment: ResearchInfrastructureEmployment;
    @Input() wizardMode: boolean;
    @Input() visibility = false;
    @Output() visibilityChange: EventEmitter<boolean> = new EventEmitter();
    @Output() saveResearchInfrastructureEmploymentChange: EventEmitter<ResearchInfrastructureEmployment> = new EventEmitter();

    public menuItems: MenuItem[] = [];
    public activeIndex = 0;

    constructor( private notificationService: HisNotificationService,
        private hisBaseGlobalsService: HisBaseGlobalsService,
        private hisUiService: HisUiService ) { }

    ngOnInit() {
        if( this.researchInfrastructureEmployment == null ) {
            this.researchInfrastructureEmployment  = new ResearchInfrastructureEmployment ();
            this.menuItems = [
                { label: this.hisUiService.translate('zul.Auswahl') },
                { label: this.hisUiService.translate('fs.res.researchInfrastructure.additionalData') }
            ];
        }
    }

    public submitResearchInfrastructureEmployment() {
        this.activeIndex = 1;
    }

    public saveEmployment() {
        this.notificationService.clear();
        let messages = this.getValidationMessages();
        if ( messages.length !== 0 ) {
            this.notificationService.error(
                messages,
                this.hisUiService.translate('global.validationerror')
            );
        } else {
            this.notificationService.infoI18n( 'de.his.javang.gefunden.change' );
            this.saveResearchInfrastructureEmploymentChange.emit( this.researchInfrastructureEmployment );
            this.closeDialog();
        }
    }

    /* close dialog action */
    public closeDialog() {
        this.visibilityChange.emit(false);
    }

    private getValidationMessages() {
        let messages = [];
        let inputRequired = this.hisUiService.translate('validation.required');

        let ddKeyFullTimePercentage =
            this.hisBaseGlobalsService.getDd('fs.res.researchInfrastructure.ResearchInfrastructureEmployment.fullTimePercentage');
        if ( !this.researchInfrastructureEmployment.fullTimePercentage
            && (ddKeyFullTimePercentage && ddKeyFullTimePercentage.required ) ) {
            messages.push(`${this.hisUiService.translate(ddKeyFullTimePercentage.identifier)}: ${inputRequired}`);
        }
        let ddKeyValidFrom =
            this.hisBaseGlobalsService.getDd('fs.res.researchInfrastructure.ResearchInfrastructureEmployment.validFrom');
        if ( !this.researchInfrastructureEmployment.validFrom
            && ( ddKeyValidFrom && ddKeyValidFrom.required ) ) {
            messages.push(`${this.hisUiService.translate(ddKeyValidFrom.identifier)}: ${inputRequired}`);
        }
        let ddKeyValidTo =
            this.hisBaseGlobalsService.getDd('fs.res.researchInfrastructure.ResearchInfrastructureEmployment.validTo');
        if ( !this.researchInfrastructureEmployment.validTo
            && ( ddKeyValidTo && ddKeyValidTo.required ) ) {
            messages.push(`${this.hisUiService.translate(ddKeyValidTo.identifier)}: ${inputRequired}`);
        }
        return messages;
    }

}
